// extracted by mini-css-extract-plugin
module.exports = {"ProfileCard":"Profile_ProfileCard__2cFuY"};